import { useState, useEffect } from 'react';
import useStockStorage from '../../store/stockStorage';
import user from '../../store/user';
import { reject } from 'lodash';


function useStockStorageHook() {
  const [, stockStorageActions] = useStockStorage();
  const [userStore] = user();
  const [listStockStorage, setListStockStorage] = useState([]);
  const [reload, setReload] = useState(false);
  const [errorApi, setErrorApi] = useState(false);

  useEffect(() => {
    if (userStore.token) {
      stockStorageActions.getStock(userStore.token).then(
        (res) => {
          setListStockStorage(res.listParts || []);
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          setErrorApi(e);
        }
      );
    }
  }, [userStore.token]);

  return {
    listStockStorage,
    reload,
    errorApi,
  };
}

export default useStockStorageHook;